// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as URLUtils$Showside from "./URLUtils.bs.js";
function isShopify(param) {
  return Belt_Option.isSome(window.Shopify);
}
function getShop(param) {
  return Belt_Option.flatMap(window.Shopify, function (shopify) {
    return shopify.shop;
  });
}
function getCountry(param) {
  return Belt_Option.flatMap(window.Shopify, function (shopify) {
    return shopify.country;
  });
}
function getLanguage(param) {
  return Belt_Option.flatMap(window.Shopify, function (shopify) {
    return shopify.locale;
  });
}
function removeForcedSizeFromURL(__x) {
  return __x.replace(/(_\d+x(\d+|)).(\w{3,4}\?)/, ".$3");
}
function makeUrl(url, w, h, dprOpt, unit) {
  var dpr = dprOpt !== undefined ? dprOpt : 1;
  var url$1 = removeForcedSizeFromURL(url);
  var width = Belt_Option.mapWithDefault(w, "", function (w) {
    return "&width=" + String(Math.imul(w, dpr));
  });
  var height = Belt_Option.mapWithDefault(h, "", function (h) {
    return "&height=" + String(Math.imul(h, dpr));
  });
  return url$1 + width + height;
}
function makeCoverUrl(url, w, h, naturalWidth, naturalHeight, dprOpt, unit) {
  var dpr = dprOpt !== undefined ? dprOpt : 1;
  var url$1 = removeForcedSizeFromURL(url);
  var param;
  if (w !== undefined && h !== undefined) {
    if (naturalWidth !== undefined) {
      if (naturalHeight !== undefined) {
        var dw = w / naturalWidth;
        var dh = h / naturalHeight;
        param = dh < dw ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
      } else {
        param = "";
      }
    } else {
      param = naturalHeight !== undefined ? "" : h < w ? "&width=" + String(Math.imul(w, dpr)) + "" : "&height=" + String(Math.imul(h, dpr)) + "";
    }
  } else {
    param = "";
  }
  return url$1 + param;
}
function isShopifyImg(src) {
  return src.includes("cdn.shopify.com");
}
function getCheckoutLink(cart, clientId, transitiveStore, checkoutLink) {
  var getVariantId = function (variantId, url) {
    var isNumeric = variantId.length === Belt_Option.getWithDefault(Belt_Option.getWithDefault(Belt_Array.get(Belt_Option.getWithDefault(Caml_option.null_to_opt(variantId.match(/([0-9]+)/)), []), 0), undefined), "").length;
    var variantIdFromLink = Belt_Array.get(Belt_Option.getWithDefault(Caml_option.null_to_opt(Belt_Option.getWithDefault(url, "").match(/variant=([0-9]+)/)), []), 1);
    if (isNumeric) {
      return variantId;
    }
    if (variantIdFromLink === undefined) {
      return variantId;
    }
    var variantIdFromLink$1 = Caml_option.valFromOption(variantIdFromLink);
    if (variantIdFromLink$1 !== undefined) {
      return variantIdFromLink$1;
    } else {
      return variantId;
    }
  };
  var baseUrl = Belt_Option.map(Belt_Option.flatMap(checkoutLink, URLUtils$Showside.maybeMakeUrl), function (prim) {
    return prim.origin;
  });
  return Belt_Option.map(Belt_Option.flatMap(baseUrl, URLUtils$Showside.maybeMakeUrl), function (baseUrl) {
    var queryParams = [];
    var token = Belt_Option.flatMap(transitiveStore, function (store) {
      return store.shopifyStorefrontAccessToken;
    });
    var queryParams$1 = token !== undefined ? Belt_Array.concat(queryParams, ["access_token=" + token + ""]) : queryParams;
    var queryParams$2 = clientId !== undefined ? Belt_Array.concat(queryParams$1, ["ref=mkr|" + clientId[0] + "|" + clientId[1] + ""]) : queryParams$1;
    var queryParams$3 = Belt_Array.joinWith(queryParams$2, "&", function (a) {
      return a;
    });
    var queryParams$4 = queryParams$3 === "" ? "" : "?" + queryParams$3;
    return baseUrl.origin + "/cart/" + Belt_Array.joinWith(Belt_Option.mapWithDefault(cart, [], function (cart) {
      return cart.items;
    }), ",", function (param) {
      return getVariantId(param.variantId, param.url) + ":" + String(param.quantity);
    }) + queryParams$4;
  });
}
export { isShopify, getShop, getCountry, getLanguage, removeForcedSizeFromURL, makeUrl, makeCoverUrl, isShopifyImg, getCheckoutLink };
/* No side effect */